import React from "react";
import PropTypes from "prop-types";
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';

export default function InfoMessage({value, type}) {
    let result = <PriorityHighOutlinedIcon/>

    if (value) {
        result = value > 9 ? "9+" : value;
    }

    return (
        <div className="InfoMessage-wrapper">
            <div className={`InfoMessage-content InfoMessage-${type}`}>
                {result}
            </div>
        </div>
    )
}

InfoMessage.propTypes = {
    value: PropTypes.number,
    type: PropTypes.oneOf(["info", "warn"]).isRequired
}